<template>
  <div class="module-wrapper">
    <div class="module-header animated fadeInDown">
      <h2>Harvests</h2>
      <button @click="addHarvest" class="btn btn-gradient-harvest">
        <i class="fas fa-plus"></i> Record Harvest
      </button>
    </div>

    <div v-if="loading" class="spinner-container">
      <i class="fas fa-spinner fa-spin fa-2x"></i> Loading Harvests...
    </div>

    <div v-else>
      <table v-if="harvests.length" class="table table-striped table-hover">
        <thead>
          <tr>
            <th>Crop</th>
            <th>Quantity</th>
            <th>Date</th>
            <th>Unit</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="harvest in harvests" :key="harvest.id">
            <td>{{ harvest.crop }}</td>
            <td>{{ harvest.quantity }}</td>
            <td>{{ harvest.date }}</td>
            <td>{{ harvest.unitName }}</td>
            <td>
              <button @click="editHarvest(harvest)" class="btn btn-sm btn-primary">Edit</button>
              <button @click="deleteHarvest(harvest.id)" class="btn btn-sm btn-danger">Delete</button>
            </td>
          </tr>
        </tbody>
      </table>

      <p v-else>No harvests recorded yet.</p>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
export default {
  name: 'HarvestsComponent',
  computed: { ...mapState('harvests', ['harvests','loading']) },
  methods: {
    addHarvest(){ this.$router.push({name:'AddHarvest'}); },
    editHarvest(harvest){ console.log('Edit', harvest); },
    deleteHarvest(id){ if(confirm('Delete this harvest?')) this.$store.dispatch('harvests/deleteHarvest', id); }
  },
  mounted(){ this.$store.dispatch('harvests/fetchHarvests'); }
};
</script>

<style scoped>
.btn-gradient-harvest { background: linear-gradient(135deg,#ff416c,#ff4b2b); color:#fff; border:none; padding:8px 15px; border-radius:6px; transition:all 0.3s;}
.btn-gradient-harvest:hover{ transform: scale(1.05);}
</style>
